import { getAxios } from "./configure-axios";
import config from "../config/vars";

let axios;

const getAxiosInstance = () => {
  if (!axios) {
    axios = getAxios();
  }
  return axios;
};

export const getItem = async (
  position,
  year,
  period,
  society,
  customer,
  documentParam,
  expiration
) => {
  const instance = getAxiosInstance();
  const itemResponse = await instance.get(
    `${config.baseUrl}${config.paths.item}?position=${position}&year=${year}&period=${period}&society=${society}&customer=${customer}&document=${documentParam}&expiration=${expiration}`
  );
  const clientResponse = await instance.get(
    `${config.baseUrl}${config.paths.searchClients}?tercero=${customer}&name=`
  );
  return {
    ...itemResponse,
    data: itemResponse.data.map(x => ({ ...x, DE_CUSTOMER_NAME: clientResponse.data[0].name }))
  };
};

export const getItemsByCustomerId = async customerId => {
  const instance = getAxiosInstance();
  return instance.get(`${config.baseUrl}${config.paths.item}/${customerId}`);
};

export default {
  getItem,
  getItemsByCustomerId
};
